module.exports = __webpack_public_path__ + "img/add.b3acbf76.svg";